export default __webpack_public_path__ + "static/media/closet4-768w.c8ebe9f4.png";